<template>
  <client-posts-toolbar
    :client="client"
    :filters="filters"
    :minimized="minimized"
    :maximize-btn="maximizeBtn"
    @update:filters="$emit('update:filters', $event)"
  >
      <edit-flagging-search-btn
        :client-id="client.id"
        icon="fa fa-flag"
        label="Add Flags"
        rounded
      />
  </client-posts-toolbar>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Client, PostFilters } from '@/type';
import ClientPostsToolbar from '@/social/post/list/client/ClientPostsToolbar.vue';
import EditFlaggingSearchBtn from '@/social/post/flagging/EditFlaggingSearchBtn.vue';

export default defineComponent({
  emits: ['update:filters'],
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
    filters: {
      type: Object as () => PostFilters,
      required: true,
    },
    minimized: {
      type: Boolean,
      default: false,
    },
    maximizeBtn: Object,
  },
  computed: {
    status(): number {
      return this.filters.statuses[0];
    },
  },
  methods: {
    selectStatus(status: number) {
      this.$emit('update:filters', Object.assign({}, this.filters, {
        statuses: [status],
      }));
    },
  },
  components: {
    EditFlaggingSearchBtn,
    ClientPostsToolbar,
  },
});
</script>
